@if (header_html) {
  <span [innerHTML]="header_html | safeHtml"></span>
}

@if (partner_html && partner_type === 'lite') {
  <span [innerHTML]="partner_html | safeHtml"></span>
}

<!-- Nav bar - NavbarType.LoggedIn -->
@if (navType === NavbarType.LoggedIn) {
  <nav class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      @if (person?.broker_id > 0 || person?.underwriter || person?.console_access) {
        <a class="navbar-brand" routerLink="/everything.policy-holders">
          <img
            id="logo"
            src="assets/0/logo.svg"
            alt="everything insure"
            />
          </a>
        }
        @if (person?.broker_id === 0 && !person?.console_access && !person?.underwriter) {
          <a class="navbar-brand" routerLink="/everything.policies-landing">
            @if (partner_img === '') {
              <img id="logo" src="assets/0/logo.svg" alt="everything insure">
            }
            @if (partner_img !== '') {
              <img id="logo" src="{{partner_img}}" alt="everything insure">
            }
          </a>
        }
        <!-- <a href="#mobile-quote-menu" class="navbar-burger" id="mobile-quote-trigger" data-toggle="modal">
        <span></span>
        <span></span>
        <span></span>
      </a> -->
      @if ((person?.broker_id > 0 || person?.underwriter || person?.console_access) && (thisPage === RouterLinks.PolicyHolders || thisPage === 'broker-dashboard' ) ) {
        <div class="navbar-search" id="global-search">
          <div class="autocomplete__wrap autocomplete__wrap--search">
            <div class="form-control__wrap has-search has-clear has-filters">
              <div class="easy-autocomplete"><input type="text" placeholder="Search" id="global-search-input" class="form-control form-control--search autocomplete" autocomplete="off"><div class="easy-autocomplete-container" id="eac-container-global-search-input"><ul style="display: none;"><li class="selected"><div class="eac-item"><svg class="icon"><use xlink:href="#search-all"></use></svg><span><b>will</b></span><small>‒ search all results</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#policies"></use></svg><span><b>Will</b>iam Simmons</span><small>Policies</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#policies"></use></svg><span><b>Will</b>iam Clarents</span><small>Policies</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#quotes"></use></svg><span>Amy <b>Will</b>iamson</span><small>Quotes</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#underwriting"></use></svg><span><b>Will</b>ey Freeberne</span><small>Underwriting</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#underwriting"></use></svg><span><b>Will</b>don Claige</span><small>Underwriting</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#claims"></use></svg><span>Gabriello <b>Will</b>ishire</span><small>Claims</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#underwriting"></use></svg><span><b>Will</b>ie Gunn</span><small>Underwriting</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#policies"></use></svg><span><b>Will</b>ie Hexam</span><small>Policies</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#underwriting"></use></svg><span><b>Will</b>ow Blann</span><small>Underwriting</small></div></li><li><div class="eac-item"><svg class="icon"><use xlink:href="#quotes"></use></svg><span><b>Will</b>amina Pafford</span><small>Quotes</small></div></li></ul></div></div>
              <span class="form-control__back" id="global-search-back">
                <svg class="icon">
                  <use xlink:href="#chevron-left-small"></use>
                </svg>
              </span>
              <span class="form-control__search">
                <svg class="icon">
                  <use xlink:href="#search"></use>
                </svg>
              </span>
              <a href="#" id="global-search-clear" class="form-control__clear form-control__clear--text">Clear</a>
              <!-- <a href="#advanced-search-modal" data-toggle="modal" data-modal-type="static" id="global-search-advanced" class="form-control__filters">
              <svg class="icon icon--sm">
                <use xlink:href="#filter"></use>
              </svg>
            </a> -->
          </div>
        </div>
      </div>
    }
    <div class="navbar-actions">
      @if (person?.broker_id > 0 || person?.underwriter || person?.console_access) {
        <a href="#global-search" class="navbar-actions__search-mobile" id="global-search-trigger">
          <svg class="icon">
            <use xlink:href="#search"></use>
          </svg>
        </a>
      }
      <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
        <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
        <div class="evi-icon">
          <ng-lottie [options]="options"></ng-lottie>
          <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
        </div>
        <div class="evi-tooltip" id="evi-tooltip">
          <p>Here if you need me</p>
        </div>
      </div>
      @if (person?.broker_id === 0 && (!person?.underwriter && !person?.console_access)) {
        <a href="javascript:;" (click)="openHelpSidesheet()" class="navbar-actions__sos d-md-none">
          <svg class="icon d-md-none">
            <use xlink:href="#support"></use>
          </svg>
        </a>
      }
      @if (person?.broker_id === 0 && (!person?.underwriter && !person?.console_access)) {
        <div class="navbar-actions__sos d-none d-md-block" >
          <a href="javascript:;" (click)="openHelpSidesheet()" class="button button--md button--secondary">Need help?</a>
        </div>
      }
      <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.NotificationsLanding]" class="navbar-actions__notify" [class.is-active]="unreadNotificationCount > 0">
        <svg class="icon">
          <use xlink:href="#envelope"></use>
        </svg>
      </a>
      <!-- new profile modal on mobile -->
      <a href="javascript:void(0)" (click)="openProfileMenu()" class="navbar-actions__profile-mobile">
        <svg class="icon"><use xlink:href="#profile"></use></svg>
      </a>
      <!-- new profile dropdown menu, replaces profile button above -->
      <div class="navbar-actions__profile">
        <div class="dropdown">
          <!-- keep this one toggle element across broker/personal views: an *ngIf on the <a>
          itself re-creates the node mid-click and drops bootstrap's dropdown instance,
          which leaves the menu stuck open (see closeOpenDropdowns in the component) -->
          <a href="#" id="broker-profile-dropdown" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <div class="dropdown-toggle__avatar">
              @if (!checkBrokerView()) {
                <svg class="icon icon--sm">
                  <use xlink:href="#profile"></use>
                </svg>
              }
              @if (checkBrokerView()) {
                <svg class="icon icon--sm">
                  <use xlink:href="#business"></use>
                </svg>
              }
            </div>
            @if (!checkBrokerView()) {
              <strong>Personal</strong>
            }
            @if (checkBrokerView() && person?.broker_id > 0) {
              <strong>Broker</strong>
            }
            @if (checkBrokerView() && person?.broker_id === 0) {
              <strong>Console</strong>
            }
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <div class="profile-drop">
              @if (person?.broker_id > 0 || person?.console_access) {
                <div  class="profile-drop__inner">
                  <a href="javascript:;" [routerLink]="RouterLinks.PolicyHolders" class="profile-drop__select {{  (thisPage === RouterLinks.PolicyHolders) || (thisPage === RouterLinks.BrokerDashboard) ? 'is-active':'' }}">
                    <div class="profile-drop__select-icon">
                      <svg class="icon icon--sm">
                        <use xlink:href="#business"></use>
                      </svg>
                    </div>
                    <div class="profile-drop__select-content">
                      @if (person?.broker_id > 0) {
                        <strong>Broker</strong>
                      }
                      @if (person?.broker_id === 0) {
                        <strong>Console</strong>
                      }
                      <small>everything.insure</small>
                    </div>
                    <svg class="profile-drop__select-indi icon">
                      <use xlink:href="#success-small"></use>
                    </svg>
                  </a>
                  <a  href="javascript:;" [routerLink]="RouterLinks.DashboardLanding" class="profile-drop__select {{thisPage !== RouterLinks.PolicyHolders ? thisPage !== RouterLinks.BrokerDashboard ? 'is-active':'' :'' }}">
                    <div class="profile-drop__select-icon">
                      <svg class="icon icon--sm">
                        <use xlink:href="#profile"></use>
                      </svg>
                    </div>
                    <div class="profile-drop__select-content">
                      <strong>Personal</strong>
                      <small> {{person?.first_name}} {{person?.last_name}}</small>
                    </div>
                    <svg class="profile-drop__select-indi icon">
                      <use xlink:href="#success-small"></use>
                    </svg>
                  </a>
                </div>
              }
              <div class="profile-drop__inner">
                <ul class="profile-drop__list list-unstyled">
                  <li>
                    <a href="javascript:;" (click)="setRoute(RouterLinks.Account)">
                      <svg class="icon">
                        <use xlink:href="#settings"></use>
                      </svg>
                      <span>Account center</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:;" (click)="logout()">
                      <svg class="icon icon--flip">
                        <use xlink:href="#login"></use>
                      </svg>
                      <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (thisPage === RouterLinks.PolicyOverview) {
      <div id="overview-sub-1" class="navbar-sub">
        @if (person?.broker_id > 0 || person?.underwriter || person?.console_access) {
          <a href="javascript:;" routerLink="/everything.policy-holders" class="navbar-sub__back">
            <svg class="icon"><use xlink:href="#arrow-left-small"></use></svg>
          </a>
        }
        @if (person?.broker_id === 0 && !person?.console_access && !person?.underwriter) {
          <a  href="javascript:;" routerLink="/everything.policies-landing" class="navbar-sub__back">
            <svg class="icon"><use xlink:href="#arrow-left-small"></use></svg>
          </a>
        }
        <div class="navbar-sub__nav">
          {{policy?.product_name}}
        </div>
      </div>
    }
    @if (thisPage === RouterLinks.PolicyOverview) {
      <div id="overview-sub-2" class="navbar-sub d-none">
        <a  href="javascript:;" (click)="backToOverview()" class="navbar-sub__back">
          <svg class="icon"><use xlink:href="#arrow-left-small"></use></svg>
        </a>
        <div class="navbar-sub__nav">
          Overview
        </div>
      </div>
    }
    @if (thisPage !== RouterLinks.PolicyOverview) {
      <div id="overview-sub-3" class="navbar-sub d-none">
        <a  href="javascript:;" (click)="backToOverview()" class="navbar-sub__back">
          <svg class="icon"><use xlink:href="#arrow-left-small"></use></svg>
        </a>
        <div class="navbar-sub__nav">
          ...
        </div>
        <div class="navbar-sub__more d-none">
          <a href="javascript:void(0);" (click)="openSidesheet()" data-sidesheet-trigger="filters" class="navbar-sub__more-item">
            <svg class="icon">
              <use xlink:href="#filter"></use>
            </svg>
          </a>
        </div>
      </div>
    }
  </div>
</nav>
}

<!-- Nav bar - NavbarType.LoggedOut-->
@if (navType === NavbarType.LoggedOut) {
  <nav class="navbar navbar--login fixed-top">
    <div class="container-fluid">
      <a class="navbar-brand" href="../">
        @if (partner_img === '') {
          <img id="logo" src="assets/0/logo.svg" alt="everything insure">
        }
        @if (partner_img !== '') {
          <img id="logo" src="{{partner_img}}" alt="everything insure">
        }
      </a>
    </div>
  </nav>
}



@if (navType === NavbarType.PolicyUnderwriters || navType === NavbarType.BrokerUnderwriterLanding || navType === NavbarType.BrokerUnderwriterCondition) {
  <nav
    class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a routerLink="/everything.policy-holders">Dashboard</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a routerLink="/{{RouterLinks.UnderwriterLanding}}">{{policyHolderName}}: <strong>{{policyProduct}}</strong></a>
          @if (underwriterCondition) {
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
            <a>{{underwriterCondition?.header}}</a>
          }
        </div>
        <a [routerLink]="RouterLinks.PolicyHolders" class="navbar-policy__back d-lg-none">
          <svg class="icon">
            <use xlink:href="#chevron-left"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-product">{{policyHolderName}}</div>
          <div class="navbar-policy__nav-select"><strong>{{policyProduct}}</strong></div>
        </div>
        <!-- <a href="#share-modal" data-toggle="modal" class="navbar-policy__share">
        <strong>Share</strong>
        <svg class="icon">
          <use xlink:href="#share"></use>
        </svg>
      </a> -->
    </div>
  </div>
</nav>
}

@if (navType === NavbarType.PolicyOverviewEdit) {
  <nav
    class="navbar navbar--central fixed-top">
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a  routerLink="/everything.policy-overview">{{policy?.product_name}}</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Policy Overview</a>
        </div>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>Policy Overview</strong></div>
        </div>
        <div class="navbar-policy__cost d-none d-lg-block">
          <p><strong><em>{{accounting?.formatMoney(policy?.prem_value)}}</em></strong> /{{policy?.frequency_short}}</p>
        </div>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.PolicyEditSummary) {
  <nav class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a href="javascript:void(0);" routerLink="/policy-edit">{{policy?.product_name}}</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Summary of Changes</a>
        </div>
        <a href="javascript:void(0);" (click)="back()" class="navbar-policy__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current">
            <strong>Summary of Changes</strong>
          </div>
        </div>
      </div>
    </div>
  </nav>
}


@if (navType === NavbarType.PolicyEdit) {
  <nav id="nav"
    class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          @if (person?.broker_id > 0 || person?.underwriter || person?.console_access) {
            <a href="javascript:void(0);" routerLink="/everything.policy-holders">{{policy?.product_name}}</a>
          }
          @if (person?.broker_id === 0 && !person?.console_access) {
            <a href="javascript:void(0);" routerLink="/everything.policies-landing">{{policy?.product_name}}</a>
          }
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Edit Policy</a>
        </div>
        <a href="#modal-submenu" data-toggle="modal" class="navbar-policy__submenu d-lg-none">
          <svg class="icon">
            <use xlink:href="#submenu-alt"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>Edit Policy</strong></div>
        </div>
        <div class="navbar-policy__save">
          <!-- <span>Save Quote</span>
          <a href="#savequote-modal" data-toggle="modal" class="icon-hover" id="save-quote-trigger">
            <svg class="icon">
              <use xlink:href="#bookmark"></use>
            </svg>
          </a> -->
          <div class="guide guide--header-right" id="guide-1-tip-2">
            <div class="guide__close">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </div>
            <div class="guide__content">
              <p>You can save your changes as a Quote and continue at a later stage.</p>
            </div>
            <div class="guide__tray">
              <div class="guide__progress">
                2 / 3
              </div>
              <div class="guide__btn">
                <a href="#guide-1-tip-3" data-guide-btn="next" class="button button--sm button--everything">Next</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.EmergencyAssist) {
  <nav
    class="navbar navbar--emergency fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-emergency">
        @if (emergencyCode) {
          <div class="navbar-emergency__code">
            <span class="emergency-code">
              <svg class="icon"><use xlink:href="#info-icon"></use></svg>
              <span class="emergency-code__text">Security Code: <span>{{emergencyCode}}</span></span>
            </span>
          </div>
        }
        <div class="navbar-emergency__breadcrumbs d-none d-lg-block">
          <a routerLink="/everything.claims-landing">Claims</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Assistance Required</a>
        </div>
        <a routerLink="/everything.claims-landing" class="navbar-emergency__back d-lg-none">
          <svg class="icon">
            <use xlink:href="#chevron-left"></use>
          </svg>
        </a>
        <div class="navbar-emergency__nav d-lg-none">
          <div class="navbar-emergency__nav-current">Assistance Required</div>
        </div>
        <a
          href="javascript:void(0)"
          (click)="requestCall()"
          class="button button--call-us button-md d-none d-lg-inline-block">
        Request a Call</a>
        <a href="#call-us__tray" data-toggle="modal" class="navbar-emergency__call d-lg-none">
          <svg class="icon">
            <use xlink:href="#navigation-phone"></use>
          </svg>
        </a>
        <a href="tel:+27 (0)87 095 2823" class="navbar-emergency__call d-none d-lg-flex">
          <svg class="icon">
            <use xlink:href="#phone-filled"></use>
          </svg>
          <strong>+27 (0)87 095 2823</strong>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.EmergencyAssistCancel) {
  <nav
    class="navbar navbar--emergency fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-emergency">
        <div class="navbar-emergency__code">
          <span class="emergency-code">
            <svg class="icon"><use xlink:href="#info-icon"></use></svg>
            <span class="emergency-code__text">Security Code: <span>{{emergencyCode}}</span></span>
          </span>
        </div>
        <div class="navbar-emergency__breadcrumbs d-none d-lg-block">
          <a routerLink="/everything.claims-landing">Claims</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Assistance Required</a>
        </div>
        <a routerLink="/everything.claims-landing" class="navbar-emergency__back d-lg-none">
          <svg class="icon">
            <use xlink:href="#chevron-left"></use>
          </svg>
        </a>
        <div class="navbar-emergency__nav d-lg-none">
          <div class="navbar-emergency__nav-current">Assistance Required</div>
        </div>
        <a href="javascript:void(0)"
          (click)="requestCall()"
          class="button button--call-us button-md d-none d-lg-inline-block">
          Request a Call
        </a>
        <a href="#call-us__tray" data-toggle="modal" class="navbar-emergency__call d-lg-none">
          <svg class="icon">
            <use xlink:href="#navigation-phone"></use>
          </svg>
        </a>
        <a href="tel:+27 (0)87 095 2823" class="navbar-emergency__call d-none d-lg-flex">
          <svg class="icon">
            <use xlink:href="#phone-filled"></use>
          </svg>
          <strong>+27 (0)87 095 2823</strong>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.ClaimSummary) {
  <nav
    class="navbar fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-claim">
        <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
          <a href="javascript:void(0);" routerLink="/everything.claims-landing">Claims</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Claim Summary</a>
        </div>
        <div class="navbar-claim__nav d-lg-none">
          <div class="navbar-claim__nav-current">Claim Summary</div>
        </div>
        <a class="navbar-claim__close"  routerLink="/everything.claims-landing" href="javascript:void(0);" data-toggle="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.ClaimSummaryUpdate) {
  <nav
    class="navbar fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-claim">
        <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
          <a href="javascript:void(0);" routerLink="/everything.claims-landing">Claims</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Edit Claim</a>
        </div>
        <a href="javascript:void(0)" (click)="openClaimsEditModalMobileModal()" class="navbar-policy__submenu d-lg-none">
          <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
        </a>
        <div class="navbar-claim__nav d-lg-none">
          <div class="navbar-claim__nav-current">Edit Claim</div>
        </div>
        <a class="navbar-claim__close" href="javascript:void(0);" [routerLink]="[RouterLinks.ClaimSummaryUpdate]">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.ClaimEdit) {
  <nav
    class="navbar fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-claim">
        <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
          <a href="javascript:void(0);" routerLink="/everything.claims-landing">Claims</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Edit Claim</a>
        </div>
        <a href="javascript:void(0)" (click)="openClaimsEditModalMobileModal()" class="navbar-policy__submenu d-lg-none">
          <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
        </a>
        <div class="navbar-claim__nav d-lg-none">
          <div class="navbar-claim__nav-current">Edit Claim</div>
        </div>
        <a class="navbar-claim__close" href="javascript:void(0);" [routerLink]="[documentPageRoute]">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.Claim) {
  <nav
    class="navbar fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-claim">
        <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
          <a routerLink="/everything.claims-landing">Claims 1</a>
          <svg class="icon">
            <use xlink:href="#chevron-right-small"></use>
          </svg>
          <a>Start Claim</a>
        </div>
        <a href="#mobile-cart" class="navbar-claim__back icon-hover d-lg-none" data-toggle="modal">
          <svg class="icon">
            <use xlink:href="#submenu-alt"></use>
          </svg>
        </a>
        <div class="navbar-claim__nav d-lg-none">
          <div class="navbar-claim__nav-current">Start Claim</div>
        </div>
        <div class="navbar-claim__feed d-none d-lg-flex">
          <span>Show</span>
          <span>Hide</span>
          <a href="#page-canvas" class="icon-hover" id="claim-feed-trigger">
            <svg class="icon">
              <use xlink:href="#feed"></use>
            </svg>
            <svg class="icon">
              <use xlink:href="#feed-filled"></use>
            </svg>
          </a>
        </div>
        <a href="javascript:;" class="navbar-claim__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>
    </div>
  </nav>
}

@if (navType === NavbarType.QuoteWizard) {
  <nav class="navbar fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      @if (person?.person_id === 0) {
        <a class="navbar-brand" href="javascript:void(0);">
          @if (partner_img === '') {
            <img id="logo" src="assets/{{sessionDetails?.category_id}}/logo.svg" alt="everything insure">
          }
          @if (partner_img !== '') {
            <img id="logo" src="{{partner_img}}" alt="everything insure">
          }
        </a>
      }
      @if (person?.person_id > 0) {
        <div class="navbar-claim">
          <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
            <a href="javascript:void(0);" routerLink="/quote-landing">Quotes</a>
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
            <a>{{globalQuestionService?.getSection('header','client_name')?.description }}</a>
          </div>
          <div class="navbar-claim__nav d-lg-none">
            <div class="navbar-claim__nav-current">{{globalQuestionService?.getSection('header','client_name')?.description}} </div>
          </div>
          <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
            <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
            <div class="evi-icon">
              <ng-lottie [options]="options"></ng-lottie>
              <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
            </div>
            <div class="evi-tooltip" id="evi-tooltip">
              <p>Here if you need me</p>
            </div>
          </div>
          <a href="#exit-modal" data-toggle="modal" class="navbar-claim__close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      }
      @if (person?.person_id === 0) {
        <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
          <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
          <div class="evi-icon">
            <ng-lottie [options]="options"></ng-lottie>
            <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
          </div>
          <div class="evi-tooltip" id="evi-tooltip">
            <p>Here if you need me</p>
          </div>
        </div>
      }
    </div>
  </nav>
}


@if (navType === NavbarType.QuoteQuestions) {
  <nav class="navbar navbar--questionnaire fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <a class="navbar-brand" href="./personal.html">
        <img id="logo" [src]="'assets/' + (sessionDetails?.category_id ? sessionDetails?.category_id : 0) + '/logo.svg'"
          alt="personal insure"/>
        </a>
        <button class="navbar-burger" id="mobile-quote-trigger" data-toggle="modal" data-target="#mobile-quote-menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="navbar-actions">
          <a href="javascript:void(0);" class="navbar-actions__item navbar-actions__item--save icon-hover" data-toggle="modal" data-target="#savequote-modal" data-tooltip="tooltip" data-placement="bottom" title="Save Quote" data-title-active="Quote Saved" data-title-closed="Save Quote">
            <svg class="icon"><use xlink:href="#bookmark"></use></svg>
          </a>
          <a href="javascript:void(0);" data-toggle="modal" class="navbar-actions__item navbar-actions__item--restart icon-hover" data-tooltip="tooltip" data-placement="bottom" title="Restart" data-target="#refresh-alert-modal">
            <svg class="icon"><use xlink:href="#restart"></use></svg>
          </a>
          <div class="navbar-actions__chat dropdown" id="chatDropdown">
            <a href="javascript:void(0);" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true"
              aria-expanded="false">
              <svg class="icon">
                <use xlink:href="#chat"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
              <div class="container">
                <div class="chat-info">
                  <div class="chat-info__avatar">
                    <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="chat-info__content">
                    <h6>Let's chat? We're online</h6>
                    <p>Hi 👋! How can we help you? Please start chatting with the next available agent.</p>
                    <a href="javascript:void(0);" (click)="chat.toggle();"  class="chat-info__trigger"><strong>Start Chat</strong></a>
                  </div>
                  <div class="chat-info__close">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-cart">
          <a href="#page-canvas" class="navbar-cart__icon is-active d-none d-lg-block" id="quote-progress-trigger-desktop">
            <svg class="icon icon--lg">
              <use xlink:href="#cart-discount"></use>
            </svg>
            <svg class="icon icon-rosette" style="display:none">
              <use xlink:href="#discount-summary-mini"></use>
            </svg>
            <span class="count">0</span>
          </a>
          <a href="javascript:void(0);" class="navbar-cart__icon d-lg-none" data-toggle="modal" data-target="#mobile-cart">
            <svg class="icon icon--lg">
              <use xlink:href="#cart-discount"></use>
            </svg>
            <svg class="icon icon-rosette" style="display:none">
              <use xlink:href="#discount-summary-mini"></use>
            </svg>
            <span class="count">0</span>
          </a>
        </div>
      </div>
    </nav>
  }

  @if (navType === NavbarType.AccountEdit) {
    <nav class="navbar navbar--central fixed-top">
      <!-- Logo in nav bar -->
      <div class="container-fluid">
        <div class="navbar-policy">
          <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
            <a>Account</a>
          </div>
          <a href="#modal-submenu" data-toggle="modal" class="navbar-policy__submenu d-lg-none">
            <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
          </a>
          <div class="navbar-policy__nav d-lg-none">
            <div class="navbar-policy__nav-current"><strong>Your Account</strong></div>
          </div>
          <a href="javascript:void(0);" [routerLink]="['/' + RouterLinks.DashboardLanding]" class="navbar-policy__close">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
    </nav>
  }


  @if (navType === NavbarType.QuestionFlow) {
    <nav class="navbar navbar--questionnaire fixed-top">
      <!-- Logo in nav bar -->
      <div class="container-fluid">
        <a class="navbar-brand navbar-brand--category" href="javascript:void(0);">
          <img id="logo" src="assets/0/logo.svg" alt="Everything.Insure" />
        </a>
        <div class="navbar-actions">
          <!-- evi -->
          <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
            <div class="evi-icon">
              <ng-lottie [options]="options"></ng-lottie>
              <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
            </div>
            <div class="evi-tooltip" id="evi-tooltip">
              <p>Here if you need me</p>
            </div>
          </div>
          <!-- progress-->
          <a href="#page-canvas"
            class="navbar-actions__item navbar-actions__item--progress d-flex icon-hover has-notice is-active"
            id="quote-progress-trigger" data-tooltip="tooltip" data-placement="bottom" title="Show Progress"
            data-title-active="Hide Progress" data-title-closed="Show Progress">
            <svg class="icon">
              <use xlink:href="#feed"></use>
            </svg>
            <svg class="icon">
              <use xlink:href="#feed-filled"></use>
            </svg>
          </a>
          <!-- example inactive save state - change icon to #bookmark-filled on save and add 'is-active' class to the <a>  -->
          @if (flow_type_id !== 2) {
            <a href="#savequote-modal" data-toggle="modal" id="save-quote-nav-btn" class="navbar-actions__item navbar-actions__item--save icon-hover d-none d-md-block" data-tooltip="tooltip" data-placement="bottom" title="" data-title-active="Quote Saved" data-title-closed="Save Quote" data-original-title="Save Quote">
              <svg class="icon"><use xlink:href="#bookmark"></use></svg>
            </a>
          }
          <!-- restart quote -->
          <a href="#refresh-alert-modal" data-toggle="modal" class="navbar-actions__item navbar-actions__item--restart icon-hover d-none d-md-block" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Restart">
            <svg class="icon"><use xlink:href="#restart"></use></svg>
          </a>
          <!-- help sidesheet -->
          <a href="javascript:void(0);" class="navbar-actions__item navbar-actions__item--sos icon-hover" data-tooltip="tooltip"
            data-placement="bottom" title="Support" (click)="openHelpSidesheet()">
            <svg class="icon">
              <use xlink:href="#help-Icon"></use>
            </svg>
          </a>
          <!-- hamburger overflow menu for mobile -->
          <a href="javascript:void(0)" class="navbar-actions__item navbar-actions__item--burger icon-hover icon-hover--transparent d-md-none" [class.is-active]="overflowMenuOpen" (click)="toggleOverflowMenu()">
            <svg class="icon">
              <use xlink:href="#menu"></use>
            </svg>
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
          <a href="{{navbar_close_button_link}}" data-toggle="modal" class="navbar-actions__item navbar-actions__item--exit d-none d-md-block">
            Exit
          </a>
        </div>
      </div>
    </nav>
  }

  @if (navType === NavbarType.QuestionFlow) {
    <div class="navbar-overflow-menu" [class.is-active]="overflowMenuOpen">
      <div class="navbar-overflow-menu__backdrop" (click)="closeOverflowMenu()"></div>
      <div class="navbar-overflow-menu__dropdown">
        <div class="navbar-overflow-menu__body">
          <ul class="menu-links">
            @if (flow_type_id !== 2) {
              <li class="menu-links__item">
                <a href="#savequote-modal" data-toggle="modal">
                  <svg class="icon">
                    <use xlink:href="#bookmark"></use>
                  </svg>
                  <p>Save quote</p>
                </a>
              </li>
            }
            <li class="menu-links__item">
              <a href="#refresh-alert-modal" data-toggle="modal">
                <svg class="icon">
                  <use xlink:href="#restart"></use>
                </svg>
                <p>Restart</p>
              </a>
            </li>
            <li class="menu-links__item">
              <a href="{{navbar_close_button_link}}" data-toggle="modal">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
                <p>Exit</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="navbar-overflow-menu__bottom">
          <h5>General enquiries</h5>
          <ul class="link-list mt-20">
            <li>
              <a href="tel:+27870952823" class="link">
                <svg class="icon">
                  <use xlink:href="#mobile-call-filled"></use>
                </svg>
                <strong class="font-semibold">+ 27 (0)87 095 2823</strong>
              </a>
            </li>
            <li>
              <a href="mailto:help@everything.insure" class="link">
                <svg class="icon">
                  <use xlink:href="#envelope-filled"></use>
                  </svg><strong class="font-semibold">help&#64;everything.insure</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    }



    @if (navType === NavbarType.QuoteUWPage || navType === NavbarType.QuoteUWUnpayablePage || navType === NavbarType.QuoteUWSubmittedPage) {
      <nav class="navbar navbar--quote fixed-top" >
        <!-- Logo in nav bar -->
        <div class="container">
          <a class="navbar-brand" routerLink="/quote-wizard" href="javascript:void(0);">
            @if (pageInfo?.length > 0) {
              <img id="logo" [src]="globalQuestionService?.getSection(sectionType.header, entryType.header_logo)?.img_path" alt="personal insure">
            }
          </a>
          <!-- <button class="navbar-burger" id="mobile-quote-trigger" data-toggle="modal" data-target="#mobile-quote-pick-cover-menu">
          <span></span>
          <span></span>
          <span></span>
        </button> -->
        <div class="navbar-quote">
          <!-- available states: is-active & is-complete -->
          <div class="navbar-quote__steps">
            <ul>
              <span class="is-spacer"></span>
              <li>
                <a class="is-complete"><span></span>
                <div>Choose</div></a>
              </li>
              <span></span>
              <li>
                <a class="is-complete"><span></span>
                <div>Confirm</div></a>
              </li>
              <span></span>
              <li>
                <a class="is-complete"><span></span>
                <div>Customise</div></a>
              </li>
              <span></span>
              <li>
                <a><span></span>
                <div>Pay</div></a>
              </li>
              <span class="is-spacer"></span>
            </ul>
          </div>
        </div>
        <div class="navbar-actions">
          <!-- example inactive save state - change icon to #bookmark-filled on save and add 'is-active' class to the <a>  -->
          @if (flow_type_id !== 2) {
            <a href="#savequote-modal" data-toggle="modal" id="save-quote-nav-btn" class="navbar-actions__item navbar-actions__item--save icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-title-active="Quote Saved" data-title-closed="Save" data-original-title="Save">
              <svg class="icon"><use xlink:href="#bookmark"></use></svg>
            </a>
          }
          <!-- -->
          <a href="#refresh-alert-modal" data-toggle="modal" class="navbar-actions__item navbar-actions__item--restart icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Restart">
            <svg class="icon"><use xlink:href="#restart"></use></svg>
          </a>
          <div class="navbar-actions__item navbar-actions__item--chat dropdown dropdown--persist" id="chatDropdown">
            <a href="#" role="button" class="icon-hover" id="chatTrigger" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Support">
              <svg class="icon"><use xlink:href="#chat"></use></svg>
            </a>
            <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
              <div class="chat-info">
                <div class="container">
                  <div class="chat-info__avatar">
                    <img src="/assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="chat-info__content">
                    <h5>Hi 👋! How can we help?</h5>
                    <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed Everything.Insure brokers are ready to assist.</p>
                    <a href="#" (click)="chat.toggle();" class="button button--primary">Start Chat</a>
                  </div>
                  <div class="chat-info__close dropdown-close">
                    <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
                  </div>
                </div>
                <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                  <div class="container">
                    <div class="accordion__item">
                      <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>We can create a quote for you</h6>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                        <div class="accordion__content">
                          <span class="tag tag--sm tag--free mb-10">Free Service</span>
                          <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                          <p>
                            <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                              <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion__item">
                      <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>Chat to a broker</h6>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                        <div class="accordion__content">
                          <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                          <p class="chat-info__accordion-call">
                            <svg class="icon icon--sm"><use xlink:href="#phone-filled"></use></svg>
                            <strong class="font-16">+27 (0)87 095 2823</strong>
                            <span> or </span>
                            <a href="javascript:void(0)" (click)="requestCall()"><strong>Request a Call</strong></a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  }

  <!-- -->

  @if (navType === NavbarType.QuotePickCover
    || navType === NavbarType.QuoteConfirmCover
    || navType === NavbarType.QuoteConfirmCoverChanges
    || navType === NavbarType.QuoteCustomizeCover
    || navType === NavbarType.QuotePayCover
    || navType === NavbarType.QuoteUWPage) {
    <nav
      class="navbar navbar--quotes fixed-top">
      <!-- Logo in nav bar -->
      @if (person?.person_id === 0) {
        <div class="container-fluid">
          <a [className]="sessionDetails?.category_id ? 'navbar-brand navbar-brand--category fill-'+sessionDetails?.css : 'navbar-brand'" routerLink="/">
            @if (pageInfo?.length > 0) {
              <svg-icon [src]="globalQuestionService.getSection(sectionType.header, entryType.header_logo)?.img_path" [applyClass]="true"></svg-icon>
            }
            @if (pageInfo?.length === 0) {
              <svg-icon [src]="'assets/' + (sessionDetails?.category_id ? sessionDetails?.category_id : 0) + '/logo.svg'" [applyClass]="true"></svg-icon>
            }
          </a>
          <div class="navbar-quote">
            <div class="navbar-quote__steps">
              <ul>
                <span class="is-spacer"></span>
                @for (step of globalQuestionService.getPageSections(sectionType.header, entryType.quote_stage); track step; let last = $last) {
                  <li>
                    <a
                      [ngClass]="step?.selected ? 'is-active' : (step?.active ? 'is-complete' : '')"
                      [routerLink]="step?.active === 1 ? step?.link_url : null ">
                      @if (step?.description) {
                        <span></span>
                      }
                      @if (step?.description) {
                        <div>{{step?.description}}</div>
                      }
                    </a>
                    <span></span>
                  </li>
                  @if (!last) {
                    <span></span>
                  }
                }
                <span class="is-spacer"></span>
              </ul>
            </div>
          </div>
          <div class="navbar-actions">
            <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
              <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
              <div class="evi-icon">
                <ng-lottie [options]="options"></ng-lottie>
                <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
              </div>
              <div class="evi-tooltip" id="evi-tooltip">
                <p>Here if you need me</p>
              </div>
            </div>
            <!-- example inactive save state - change icon to #bookmark-filled on save and add 'is-active' class to the <a>  -->
            @if (flow_type_id !== 2) {
              <a href="#savequote-modal" data-toggle="modal" id="save-quote-nav-btn" class="navbar-actions__item navbar-actions__item--save icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-title-active="Quote Saved" data-title-closed="Save" data-original-title="Save">
                <svg class="icon"><use xlink:href="#bookmark"></use></svg>
              </a>
            }
            <!-- -->
            <a href="#refresh-alert-modal" data-toggle="modal" class="navbar-actions__item navbar-actions__item--restart icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Restart">
              <svg class="icon"><use xlink:href="#restart"></use></svg>
            </a>
            <div class="navbar-claim__item navbar-claim__item--chat dropdown dropdown--persist" id="chatDropdown">
              <a href="javascript:void(0);" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" data-tooltip="tooltip" data-placement="bottom" title="Support"
                aria-haspopup="true"
                aria-expanded="false">
                <svg class="icon"><use xlink:href="#chat"></use></svg>
              </a>
              <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                <div class="chat-info">
                  <div class="container">
                    <div class="chat-info__avatar">
                      <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                    </div>
                    <div class="chat-info__content">
                      <h5>Hi 👋! How can we help?</h5>
                      <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed
                      Everything.Insure brokers are ready to assist.</p>
                      <a href="javascript:void(0);" (click)="chat.toggle();" class="button button--primary">Start Chat</a>
                    </div>
                    <div class="chat-info__close dropdown-close" data-toggle="dropdown">
                      <svg class="icon">
                        <use xlink:href="#close-circle-small"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                    <div class="container">
                      <div class="accordion__item">
                        <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>We can create a quote for you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <span class="tag tag--sm tag--free mb-10">Free Service</span>
                            <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                            <p>
                              <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                                <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">+27 (0)87 095 2823</strong>
                              <span> or </span>
                              <a href="javascript:void(0)" (click)="requestCall()"><strong>Request a Call</strong></a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="mailto:help@everything.insure?subject=Help%20me%20on%20Everything.Insure&body=Please%20could%20you%20contact%20me%20to%20assist%20with%20my%20insurance%20needs%20on%20Everything.Insure." class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (person?.person_id > 0) {
        <div class="container-fluid">
          <div class="navbar-claim">
            <div class="navbar-claim__breadcrumbs d-none d-lg-flex">
              <a href="javascript:void(0);" [routerLink]="[documentPageRoute]">Quotes</a>
              <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
              <a>{{globalQuestionService?.getSection('header','client_name')?.description ? globalQuestionService?.getSection('header','client_name')?.description: 'Start Quote' }}</a>
            </div>
            <div class="navbar-quote">
              <div class="navbar-quote__steps">
                <ul>
                  <span class="is-spacer"></span>
                  @for (step of globalQuestionService.getPageSections(sectionType.header, entryType.quote_stage); track step; let last = $last) {
                    <li>
                      <a
                        [ngClass]="step?.selected ? 'is-active' : (step?.active ? 'is-complete' : '')"
                        [routerLink]="step?.active === 1 ? step?.link_url : null ">
                        @if (step?.description) {
                          <span></span>
                        }
                        @if (step?.description) {
                          <div>{{step?.description}}</div>
                        }
                      </a>
                      <span></span>
                    </li>
                    @if (!last) {
                      <span></span>
                    }
                  }
                  <span class="is-spacer"></span>
                </ul>
              </div>
            </div>
            <div class="navbar-claim__nav d-lg-none">
              <div class="navbar-claim__nav-current">{{globalQuestionService?.getSection('header','client_name')?.description ? globalQuestionService?.getSection('header','client_name')?.description  : 'Start Quote' }}</div>
            </div>
            <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
              <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
              <div class="evi-icon">
                <ng-lottie [options]="options"></ng-lottie>
                <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
              </div>
              <div class="evi-tooltip" id="evi-tooltip">
                <p>Here if you need me</p>
              </div>
            </div>
            <!-- example inactive save state - change icon to #bookmark-filled on save and add 'is-active' class to the <a>  -->
            @if (flow_type_id !== 2) {
              <a href="#savequote-modal" data-toggle="modal" id="save-quote-nav-btn" class="navbar-claim__item navbar-claim__item--save icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-title-active="Quote Saved" data-title-closed="Save" data-original-title="Save">
                <svg class="icon"><use xlink:href="#bookmark"></use></svg>
              </a>
            }
            <!-- -->
            <a href="#refresh-alert-modal" data-toggle="modal" class="navbar-claim__item navbar-claim__item--restart icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Restart">
              <svg class="icon"><use xlink:href="#restart"></use></svg>
            </a>
            <div class="navbar-claim__item navbar-claim__item--chat dropdown dropdown--persist" id="chatDropdown">
              <a href="javascript:;" role="button" class="icon-hover" id="chatTrigger" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Support">
                <svg class="icon"><use xlink:href="#chat"></use></svg>
              </a>
              <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                <div class="chat-info">
                  <div class="container">
                    <div class="chat-info__avatar">
                      <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                    </div>
                    <div class="chat-info__content">
                      <h5>Hi 👋! How can we help?</h5>
                      <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed
                      Everything.Insure brokers are ready to assist.</p>
                      <a href="javascript:void(0);" (click)="chat.toggle();" class="button button--primary">Start Chat</a>
                    </div>
                    <div class="chat-info__close dropdown-close" data-dismiss="modal" data-toggle="dropdown">
                      <svg class="icon">
                        <use xlink:href="#close-circle-small"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                    <div class="container">
                      <div class="accordion__item">
                        <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>We can create a quote for you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <span class="tag tag--sm tag--free mb-10">Free Service</span>
                            <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                            <p>
                              <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                                <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">+27 (0)87 095 2823</strong>
                              <span> or </span>
                              <a href="javascript:void(0)" (click)="requestCall()"><strong>Request a Call</strong></a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="mailto:help@everything.insure?subject=Help%20me%20on%20Everything.Insure&body=Please%20could%20you%20contact%20me%20to%20assist%20with%20my%20insurance%20needs%20on%20Everything.Insure." class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a href="#nav-action-sheet" data-toggle="modal" class="navbar-claim__item navbar-claim__item--actions" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="More">
              <svg class="icon"><use xlink:href="#more"></use></svg>
            </a>
            <a href="#exit-modal" data-toggle="modal" class="navbar-claim__item navbar-claim__item--close icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Close">
              <svg class="icon"><use xlink:href="#close-medium"></use></svg>
            </a>
          </div>
        </div>
      }
    </nav>
  }


  @if (navType === NavbarType.QuoteUnderwriting) {
    <nav class="navbar fixed-top" style="top: 0px;">
      <!-- Logo in nav bar -->
      <div class="container">
        <a class="navbar-brand" [routerLink]="'/'">
          <img
            [src]="'assets/' + (sessionDetails?.category_id ? sessionDetails?.category_id : 0) + '/logo.svg'"
            alt="personal insure">
          </a>
          <button class="navbar-burger" id="mobile-quote-underwriting-trigger" data-toggle="modal"
            data-target="#mobile-quote-pick-cover-menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div class="navbar-actions">
            <!-- example inactive save state - change icon to #bookmark-filled on save and add 'is-active' class to the <a>  -->
            <a href="#savequote-modal" data-toggle="modal" id="save-quote-nav-btn" class="navbar-actions__item navbar-actions__item--save icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-title-active="Quote Saved" data-title-closed="Save Quote" data-original-title="Save Quote">
              <svg class="icon"><use xlink:href="#bookmark"></use></svg>
            </a>
            <!-- -->
            <a href="#refresh-alert-modal" data-toggle="modal" class="navbar-actions__item navbar-actions__item--restart icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Restart">
              <svg class="icon"><use xlink:href="#restart"></use></svg>
            </a>
            <div class="navbar-actions__item navbar-actions__item--chat dropdown dropdown--persist" id="chatDropdown">
              <a href="javascript:void(0);" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" data-tooltip="tooltip" data-placement="bottom" title="Support"
                aria-haspopup="true"
                aria-expanded="false">
                <svg class="icon"><use xlink:href="#chat"></use></svg>
              </a>
              <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                <div class="chat-info">
                  <div class="container">
                    <div class="chat-info__avatar">
                      <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
                    </div>
                    <div class="chat-info__content">
                      <h5>Hi 👋! How can we help?</h5>
                      <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed
                      Everything.Insure brokers are ready to assist.</p>
                      <a href="javascript:void(0);" (click)="chat.toggle();" class="button button--primary">Start Chat</a>
                    </div>
                    <div class="chat-info__close dropdown-close" data-toggle="dropdown">
                      <svg class="icon">
                        <use xlink:href="#close-circle-small"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                    <div class="container">
                      <div class="accordion__item">
                        <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>We can create a quote for you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <span class="tag tag--sm tag--free mb-10">Free Service</span>
                            <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                            <p>
                              <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                                <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">+27 (0)87 095 2823</strong>
                              <span> or </span>
                              <a href="javascript:void(0)" (click)="requestCall()">
                                <strong>Request a Call</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    }

    @if (navType === NavbarType.Documentation
      || navType === NavbarType.PolicyTranscript
      || navType === NavbarType.ClaimTranscript
      || navType === NavbarType.MembershipTranscript
      || navType === NavbarType.CertificateOfCover) {
      <nav
        class="navbar navbar--central fixed-top" style="top: 0px;">
        <!-- Logo in nav bar -->
        <div class="container">
          <a [className]="policy?.product_category_id ? 'navbar-brand navbar-brand--category' : 'navbar-brand'" href="javascript:void(0);">
            <svg-icon id="logo" src="assets/0/logo.svg" alt="Everything.Insure"></svg-icon>
          </a>
          <div class="navbar-actions">
            <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
              <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
              <div class="evi-icon">
                <ng-lottie [options]="options"></ng-lottie>
                <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
              </div>
              <div class="evi-tooltip" id="evi-tooltip">
                <p>Here if you need me</p>
              </div>
            </div>
            <div class="navbar-actions__chat dropdown">
              <a href="javascript:void(0);" role="button" id="chatTrigger-modal" data-toggle="dropdown" data-display="static" title="Chat"
                aria-haspopup="true" aria-expanded="false">
                <strong class="d-none d-sm-inline">Got questions?</strong>
                <svg class="icon">
                  <use xlink:href="#chat"></use>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu--chat dropdown-menu--chat-modal" aria-labelledby="chatTrigger-modal">
                <div class="container">
                  <div class="chat-info">
                    <div class="chat-info__avatar">
                      <img
                        src="assets/{{sessionDetails?.category_id ? sessionDetails?.category_id : 0}}/avatar/happy.png"
                        class="img-fluid" alt="">
                      </div>
                      <div class="chat-info__content">
                        <h6>Let's chat? We're online</h6>
                        <p>Hi 👋! How can we help you? Please start chatting with the next available agent.</p>
                        <a href="javascript:void(0);" (click)="chat.toggle();" class="chat-info__trigger">
                          <strong>Start Chat</strong></a>
                        </div>
                        <div class="chat-info__close">
                          <svg class="icon">
                            <use xlink:href="#close-circle-small"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a href="javascript:void(0);" [routerLink]="[documentPageRoute]"
                class="navbar__close">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </a>
            </div>
          </nav>
        }

        @if (navType === NavbarType.DealAlert) {
          <nav class="navbar navbar--central fixed-top">
            <!-- Logo in nav bar -->
            <div class="container-fluid">
              <div class="navbar-policy">
                <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
                  <a href="javascript:void(0);" routerLink="/quote-wizard">Quotes</a>
                  <svg class="icon">
                    <use xlink:href="#chevron-right-small"></use>
                  </svg>
                  <a>Better Deal</a>
                </div>
                <div class="navbar-policy__nav d-lg-none">
                  <div class="navbar-policy__nav-current">Better Deal</div>
                </div>
                <div class="navbar-policy__chat dropdown dropdown--persist" id="chatDropdown">
                  <a href="javascript:void(0);" role="button" id="chatTrigger-modal" data-toggle="dropdown" data-display="static" title="Chat"
                    aria-haspopup="true" aria-expanded="false">
                    <strong class="d-none d-sm-inline">Got questions?</strong>
                    <svg class="icon">
                      <use xlink:href="#chat"></use>
                    </svg>
                  </a>
                  <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                    <div class="chat-info">
                      <div class="container">
                        <div class="chat-info__avatar">
                          <img
                            [src]="'assets/' + (sessionDetails?.category_id ? sessionDetails?.category_id : 0) + '/avatar/happy.png'"
                            class="img-fluid"
                            alt=""
                            />
                          </div>
                          <div class="chat-info__content">
                            <h5>Hi 👋! How can we help?</h5>
                            <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed
                            Everything.Insure brokers are ready to assist.</p>
                            <a href="javascript:void(0);" (click)="chat.toggle();" class="button button--primary">Start Chat</a>
                          </div>
                          <div class="chat-info__close dropdown-close" data-toggle="dropdown">
                            <svg class="icon">
                              <use xlink:href="#close-circle-small"></use>
                            </svg>
                          </div>
                        </div>
                        <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                          <div class="container">
                            <div class="accordion__item">
                              <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                                <div class="accordion__title-text">
                                  <h6>We can create a quote for you</h6>
                                </div>
                                <div class="accordion__title-caret">
                                  <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                                </div>
                              </a>
                              <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                                <div class="accordion__content">
                                  <span class="tag tag--sm tag--free mb-10">Free Service</span>
                                  <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                                  <p>
                                    <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                                      <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="accordion__item">
                              <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                                <div class="accordion__title-text">
                                  <h6>Chat to a broker</h6>
                                </div>
                                <div class="accordion__title-caret">
                                  <svg class="icon">
                                    <use xlink:href="#chevron-down-smaller"></use>
                                  </svg>
                                </div>
                              </a>
                              <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                                <div class="accordion__content">
                                  <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                                  <p class="chat-info__accordion-call">
                                    <svg class="icon icon--sm">
                                      <use xlink:href="#phone-filled"></use>
                                    </svg>
                                    <strong class="font-16">+27 (0)87 095 2823</strong>
                                    <span>or</span>
                                    <a href="javascript:void(0)" (click)="requestCall()">
                                      <strong>Request a Call</strong>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a routerLink="/" class="navbar-policy__close">
                    <svg class="icon">
                      <use xlink:href="#close-medium"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </nav>
          }

          @if (navType === NavbarType.QuoteCovered) {
            <nav class="navbar fixed-top" style="top: 0px;">
              <!-- Logo in nav bar -->
              <div class="container-fluid">
                <a class="navbar-brand navbar-brand--category" routerLink="/">
                  @if (pageInfo?.length > 0) {
                    <img id="logo" [src]="globalQuestionService.getSection(sectionType.header, entryType.header_logo)?.img_path ? globalQuestionService.getSection(sectionType.header, entryType.header_logo)?.img_path :'assets/0/logo.svg'" alt="personal insure">
                  }
                </a>
                <div class="navbar-actions">
                  <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
                    <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
                    <div class="evi-icon">
                      <ng-lottie [options]="options"></ng-lottie>
                    </div>
                    <div class="evi-tooltip" id="evi-tooltip">
                      <p>Chat to me about insurance</p>
                    </div>
                  </div>
                  <!--
                  <div class="navbar-actions__chat dropdown dropdown--persist" id="chatDropdown">
                    <a href="javascript:void(0);" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true"
                      aria-expanded="false">
                      <span class="d-none d-lg-inline">Help</span>
                      <svg class="icon">
                        <use xlink:href="#chat"></use>
                      </svg>
                    </a>
                    <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
                      <div class="chat-info">
                        <div class="container">
                          <div class="chat-info__avatar">
                            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
                          </div>
                          <div class="chat-info__content">
                            <h5>Hi 👋! How can we help?</h5>
                            <p>Start chatting with the next available agent, or if you prefer a friendly voice our licensed
                            Everything.Insure brokers are ready to assist.</p>
                            <a href="javascript:void(0);" onclick="Tawk_API.toggle();" class="button button--primary">Start Chat</a>
                          </div>
                          <div class="chat-info__close dropdown-close">
                            <svg class="icon">
                              <use xlink:href="#close-circle-small"></use>
                            </svg>
                          </div>
                        </div>
                        <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                          <div class="container">
                            <div class="accordion__item">
                              <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                                <div class="accordion__title-text">
                                  <h6>We can create a quote for you</h6>
                                </div>
                                <div class="accordion__title-caret">
                                  <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                                </div>
                              </a>
                              <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                                <div class="accordion__content">
                                  <span class="tag tag--sm tag--free mb-10">Free Service</span>
                                  <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                                  <p>
                                    <a href="mailto:help@everything.insure?subject=Quote%20request%20{{titleCasePipe.transform(sessionDetails?.css)}}.Insure&body=Hi%20there%0D%0A%0D%0APlease%20could%20you%20provide%20me%20with%20quotes%20for%20insurance%20to%20match%20my%20attached%20schedule.%0D%0A%0D%0ALook%20forward%20to%20hearing%20from%20you." class="button-control button-control--tight">
                                      <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="accordion__item">
                              <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                                <div class="accordion__title-text">
                                  <h6>Chat to a broker</h6>
                                </div>
                                <div class="accordion__title-caret">
                                  <svg class="icon">
                                    <use xlink:href="#chevron-down-smaller"></use>
                                  </svg>
                                </div>
                              </a>
                              <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                                <div class="accordion__content">
                                  <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                                  <p class="chat-info__accordion-call">
                                    <svg class="icon icon--sm">
                                      <use xlink:href="#phone-filled"></use>
                                    </svg>
                                    <strong class="font-16">+27 (0)87 095 2823</strong>
                                    <span> or </span>
                                    <a href="javascript:void(0)" (click)="requestCall()"><strong> Request a Call</strong></a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <a href="javascript:;" (click)="openHelpSidesheet()" class="navbar-actions__item navbar-actions__item--sos icon-hover" data-tooltip="tooltip"
                    data-placement="bottom" title="Need help?">
                    <svg class="icon">
                      <use xlink:href="#help-Icon"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </nav>
          }
          @if (navType === NavbarType.QuoteOutstanding) {
            <nav class="navbar navbar--questionnaire fixed-top">
              <!-- Logo in nav bar -->
              <div class="container-fluid">
                <a class="navbar-brand navbar-brand--category" href="./home.html">
                  <img id="logo" src="/assets/0/logo.svg" alt="Everything Insure" />
                </a>
                <button class="navbar-burger" id="mobile-quote-trigger" data-toggle="modal" data-target="#mobile-quote-menu">
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
                <div class="navbar-actions">
                  <div class="navbar-actions__item navbar-actions__item--evi ml-20  ml-lg-0" id="evi-trigger" (click)="this.componentsService.sendEviCommand('expand')">
                    <!-- <img src="/assets/icn/evi.svg" class="icon"> -->
                    <div class="evi-icon">
                      <ng-lottie [options]="options"></ng-lottie>
                      <!-- <lottie-player src="assets/evi-icon.json" background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
                    </div>
                    <div class="evi-tooltip" id="evi-tooltip">
                      <p>Chat to me about insurance</p>
                    </div>
                  </div>
                  <a href="javascript:;" (click)="openHelpSidesheet()" class="navbar-actions__item navbar-actions__item--sos icon-hover" data-tooltip="tooltip"
                    data-placement="bottom" title="Need help?">
                    <svg class="icon">
                      <use xlink:href="#help-Icon"></use>
                    </svg>
                  </a>
                  <!-- <a href="#" class="navbar-actions__item navbar-actions__item--exit">Exit</a> -->
                </div>
              </div>
            </nav>
          }

          @if (navType === NavbarType.ComplianceVault || navType === NavbarType.EditProfile) {
            <nav class="navbar navbar--central fixed-top" style="top: 0px;">
              <!-- Logo in nav bar -->
              <div class="container-fluid">
                <div class="navbar-policy">
                  <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
                    <a href="javascript:;"  routerLink="/everything.policy-holders" >{{mode}}</a>
                    <svg class="icon">
                      <use xlink:href="#chevron-right-small"></use>
                    </svg>
                    <a>{{policy?.person[0].first_name}} {{policy?.person[0].last_name}}</a>
                  </div>
                  <a href="javascript:;"  routerLink="/everything.policy-holders" class="navbar-policy__close">
                    <svg class="icon">
                      <use xlink:href="#close-medium"></use>
                    </svg>
                  </a>
                  <a href="javascript:;"  routerLink="/everything.policy-holders" class="navbar-policy__back d-lg-none">
                    <svg class="icon">
                      <use xlink:href="#chevron-left"></use>
                    </svg>
                  </a>
                  <div class="navbar-policy__nav d-lg-none">
                    <div class="navbar-policy__nav-current">{{policy?.person[0].first_name}} {{policy?.person[0].last_name}}</div>
                  </div>
                </div>
              </div>
            </nav>
          }


          @if (partner_html && partner_type === 'full' && navType !== NavbarType.QuestionFlow) {
            <span [innerHTML]="partner_html | safeHtml"></span>
          }

          <app-request-call #requestCallComponent></app-request-call>

          <div class="sidesheet" id="help-sidesheet">
            <div class="sidesheet__inner">
              <div class="sidesheet__header">
                <a href="javascript:;" (click)="closeHelpSidesheet()" class="sidesheet__header-back">
                  <svg class="icon">
                    <use xlink:href="#arrow-left-small"></use>
                  </svg>
                </a>
                <h5>Get help</h5>
              </div>
              <div class="sidesheet__body">

                <div class="get-help">

                  <div class="get-help__avatar">
                    <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="get-help__title">
                    <h4>Hi! How can we help?</h4>
                  </div>

                  <div class="get-help__more mt-30">

                    <div class="accordion accordion--sm accordion--gethelp" id="accordion-get-help">

                      <div class="accordion__item">
                        <a href="javascript:;" (click)="chatWithEvi()" data-dismiss="sidesheet" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <div class="evi-icon evi-icon--lg">
                              <ng-lottie [options]="options"></ng-lottie>
                            </div>
                            <h6>Chat with evi</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>

                      <div class="accordion__item">
                        <a href="javascript:void(0)" (click)="requestCall()" data-toggle="modal" data-dismiss="sidesheet" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Request a call</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>

                      <div class="accordion__item">
                        <a href="javascript:;" (click)="openChat()" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Start a live chat</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>

                      <div class="accordion__item">
                        <a href="#get-help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="get-help-2" data-parent="#accordion-get-help" style="">
                          <div class="accordion__content"><div class="accordion__content-inner">

                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in
                            touch.</p>
                            <ul class="accordion__list list-unstyled mb-0">
                              <li>
                                <a href="tel:+27112917354">
                                  <svg class="icon">
                                    <use xlink:href="#mobile-call-filled"></use>
                                  </svg>
                                  <strong class="font-semibold">+ 27 (0)87 095 2823</strong>
                                </a>
                              </li>
                              <li>
                                <a href="javascript:void(0)" (click)="requestCall()" data-toggle="modal" data-dismiss="sidesheet">
                                  <svg class="icon">
                                    <use xlink:href="#phone-filled"></use>
                                  </svg>
                                  <strong class="font-semibold">Request a call with a broker</strong>
                                </a>
                              </li>
                              <li>
                                <a href="javascript:;" (click)="openChat()">
                                  <svg class="icon">
                                    <use xlink:href="#mobile-call-filled"></use>
                                  </svg>
                                  <strong class="font-semibold">Live chat with a broker</strong>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="accordion__item">
                      <a href="#get-help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>We can create a quote for you</h6>
                          <span class="tag tag--sm tag--free">Free Service</span>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-down-smaller"></use>
                          </svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="get-help-1" data-parent="#accordion-get-help">
                        <div class="accordion__content"><div class="accordion__content-inner">

                          <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that to build a new quote for you!</p>
                          <p>
                            <a href="#create-quote-modal" data-toggle="modal" data-dismiss="sidesheet" class="button-control button-control--tight">
                              <svg class="icon icon--sm">
                                <use xlink:href="#upload"></use>
                                </svg><strong class="font-semibold">Upload a schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="get-help__general mt-30">
                  <h5>General enquiries</h5>
                  <ul class="accordion__list list-unstyled mt-10 mb-0">
                    <li>
                      <a href="#" class="button-control">
                        <svg class="icon">
                          <use xlink:href="#mobile-call-filled"></use>
                        </svg>
                        <strong class="font-semibold">+ 27 (0)87 095 2823</strong>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:help@everything.insure" class="button-control">
                        <svg class="icon">
                          <use xlink:href="#envelope-filled"></use>
                        </svg>
                        <strong class="font-semibold">help&#64;everything.insure</strong>
                      </a>
                    </li>
                  </ul>
                </div>



              </div>

              @if (hasProductTour()) {
                <div class="get-help__tray">
                  <a href="javascript:;" (click)="replayProductTour()" class="button-control button-control--sm">
                    <svg class="icon"><use xlink:href="#repeat"></use></svg><small><strong>Replay product tour</strong></small>
                  </a>
                </div>
              }

            </div>
          </div>
        </div>
        <div class="modal fade modal--tray"
          id="call-us__tray"
          tabindex="-1"
          role="dialog"
          aria-labelledby="call-us__tray"
          aria-modal="true">
          <div class="modal-dialog">
            <div class="modal-content modal-traymenu">
              <div class="container">
                <div class="modal-traymenu__list list-unstyled">

                  <a class="modal-traymenu__list-item">
                    <svg class="icon"><use xlink:href="#navigation-phone"></use></svg>
                    <div>Call us at +27 (0)87 095 2823</div>
                  </a>
                  <a href="javascript:void(0)" (click)="requestCall()" class="modal-traymenu__list-item" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#request-call"></use></svg>
                    <div>Request a Call</div>
                  </a>
                </div>

                <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
                  <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  <div>Close</div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- mobile menu modal -->
        <div class="modal fade modal--fullscreen" id="mobile-quote-menu" tabindex="-1" role="dialog"
          aria-labelledby="mobile-quote-menu" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-everything modal-everything--central">
              <div class="modal-everything__header">
                <div class="modal-everything__logo">
                  <img id="logo" src="assets/0/logo.svg" alt="Everything.Insure"/>
                </div>

                <div class="modal-everything__nav">
                  @if (false) {
                    <a href="javascript:void(0);" class="modal-everything__notify is-active">
                      <svg class="icon">
                        <use xlink:href="#notifications"></use>
                      </svg>
                    </a>
                  }

                  <button type="button" data-dismiss="modal" aria-label="Close" class="modal-everything__close">
                    <svg class="icon">
                      <use xlink:href="#close-medium"></use>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="modal-everything__content">

                @if (partner_html && partner_type === 'full') {
                  <span [innerHTML]="partner_html | safeHtml"></span>
                }

                <nav class="central-nav">
                  <ul class="central-nav__list list-unstyled">
                    @if ((thisPage !== RouterLinks.PolicyHolders) || (person?.broker_id === 0 && !person?.console_access)) {
                      <li [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                        @if (inProgress) {
                          <a href="javascript:void(0);"
                            [routerLink]="['/' + RouterLinks.DashboardLanding]"
                            (click)="closeMenuModal()">
                            <svg class="icon">
                              <use xlink:href="#dashboard"></use>
                            </svg>
                            <span>Dashboard</span>
                          </a>
                        }
                      </li>
                    }

                    @if ((thisPage !== RouterLinks.PolicyHolders) || (person?.broker_id === 0 && !person?.console_access)) {
                      <li  [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                        <a href="javascript:void(0);"
                          [routerLink]="['/' + RouterLinks.PoliciesLanding]"
                          (click)="closeMenuModal()">
                          <svg class="icon">
                            <use xlink:href="#policies"></use>
                          </svg>
                          <span>Policies</span>
                        </a>
                      </li>
                    }
                    @if ((thisPage !== RouterLinks.PolicyHolders) || (person?.broker_id === 0 && !person?.console_access)) {
                      <li  [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                        <a href="javascript:void(0);"
                          [routerLink]="['/' + RouterLinks.MembershipLanding]"
                          (click)="closeMenuModal()">
                          <svg class="icon">
                            <use xlink:href="#policies"></use>
                          </svg>
                          <span>Membership</span>
                        </a>
                      </li>
                    }

                    @if ((thisPage !== RouterLinks.PolicyHolders) || (person?.broker_id === 0 && !person?.console_access)) {
                      <li  [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                        @if (inProgress) {
                          <a href="javascript:void(0);"
                            [routerLink]="['/' + RouterLinks.QuoteLanding]"
                            (click)="closeMenuModal()">
                            <svg class="icon">
                              <use xlink:href="#quotes"></use>
                            </svg>
                            <span>Quotes</span>
                          </a>
                        }
                      </li>
                    }

                    @if ((thisPage !== RouterLinks.PolicyHolders) || (person?.broker_id === 0 && !person?.console_access)) {
                      <li [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                        @if (inProgress) {
                          <a href="javascript:void(0);"
                            [routerLink]="['/' + RouterLinks.ClaimsLanding]"
                            (click)="closeMenuModal()">
                            <svg class="icon">
                              <use xlink:href="#claims"></use>
                            </svg>
                            <span>Claims</span>
                          </a>
                        }
                      </li>
                    }

                    <li [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                      <a href="javascript:void(0);"
                        [routerLink]="['/' + RouterLinks.Account]"
                        (click)="closeMenuModal()">
                        <svg class="icon">
                          <use xlink:href="#profile"></use>
                        </svg>
                        <span>Account</span>
                      </a>
                    </li>
                  </ul>

                  <ul class="central-nav__list list-unstyled">
                    <li>
                      <a href="javascript:void(0)" data-dismiss="modal" (click)="logout()">
                        <svg class="icon">
                          <use xlink:href="#pause"></use>
                        </svg>
                        <span>Logout</span>
                      </a>
                    </li>

                    @if (person?.broker === 0 && !person?.console_access) {
                      <li >
                        <a href="javascript:void(0);" (click)="chat.toggle();">
                          <svg class="icon">
                            <use xlink:href="#chat"></use>
                          </svg>
                          <span>Support</span>
                        </a>
                      </li>
                    }
                  </ul>
                </nav>

                @if (person?.broker === 0 && !person?.console_access) {
                  <div class="central-getassistance">
                    <a href="javascript:void(0);" (click)="startSOSFlow()" data-dismiss="modal" class="central-getassistance__btn">
                      <svg class="icon">
                        <use xlink:href="#navigation-sos"></use>
                      </svg>
                      Get Assistance
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- /modal -->

        <!-- tray menu modal (mobile only) -->


        <div class="modal fade modal--tray" id="modal-traymenu-profile" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-profile" aria-modal="true">
          <div class="modal-dialog">
            <div class="modal-content modal-traymenu">
              <div class="profile-drop">

                @if (person?.broker_id > 0 || person?.console_access) {
                  <div  class="profile-drop__inner">
                    <!-- icon versions -->
                    <a href="javascript:;" [routerLink]="RouterLinks.PolicyHolders" class="profile-drop__select {{  (thisPage === RouterLinks.PolicyHolders) || (thisPage === RouterLinks.BrokerDashboard) ? 'is-active':'' }}">
                      <div class="profile-drop__select-icon">
                        <svg class="icon icon--sm">
                          <use xlink:href="#business"></use>
                        </svg>
                      </div>
                      <div class="profile-drop__select-content">
                        @if (person?.broker_id > 0) {
                          <strong>Broker</strong>
                        }
                        @if (person?.broker_id === 0) {
                          <strong>Console</strong>
                        }
                        <small>everything.insure</small>
                      </div>
                      <svg class="profile-drop__select-indi icon">
                        <use xlink:href="#success-small"></use>
                      </svg>
                    </a>
                    <a href="javascript:;" [routerLink]="RouterLinks.DashboardLanding"  class="profile-drop__select {{thisPage !== RouterLinks.PolicyHolders ? thisPage !== RouterLinks.BrokerDashboard ? 'is-active':'' :'' }}">
                      <div class="profile-drop__select-icon">
                        <svg class="icon icon--sm">
                          <use xlink:href="#profile"></use>
                        </svg>
                      </div>
                      <div class="profile-drop__select-content">
                        <strong>Personal</strong>
                        <small>{{person?.first_name}} {{person?.last_name}}</small>
                      </div>
                      <svg class="profile-drop__select-indi icon">
                        <use xlink:href="#success-small"></use>
                      </svg>
                    </a>
                  </div>
                }
                <div class="profile-drop__inner">
                  <ul class="profile-drop__list list-unstyled">
                    <li>
                      <a href="javascript:;" (click)="closeProfileAndNavigate(RouterLinks.Account)">
                        <svg class="icon">
                          <use xlink:href="#settings"></use>
                        </svg>
                        <span>Account center</span>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" (click)="closeProfileAndLogout()">
                        <svg class="icon icon--flip">
                          <use xlink:href="#login"></use>
                        </svg>
                        <span>Logout</span>
                      </a>
                    </li>
                    <!-- TO BE REMOVED
                    <li>
                      <a href="#" data-dismiss="modal">
                        <svg class="icon">
                          <use xlink:href="#close-medium"></use>
                        </svg>
                        <span>Close</span>
                      </a>
                    </li> -->
                  </ul>
                </div>

              </div>





            </div>
          </div>
        </div>
        <!-- /modal -->

        <div class="modal fade modal--fullscreen" id="mobile-quote-pick-cover-menu" tabindex="-1" role="dialog"
          aria-labelledby="mobile-quote-pick-cover-menu" aria-modal="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">

                <div class="container">
                  <div class="modal-quote-header">
                    <div class="modal-quote-header__logo">
                      <img id="quote-pick-cover-logo" src="assets/3/logo.svg"
                        alt="personal insurance">
                      </div>
                      <button type="button" data-dismiss="modal" aria-label="Close" class="modal-quote-header__close">
                        <svg class="icon">
                          <use xlink:href="#close-circle-small"></use>
                        </svg>
                      </button>
                    </div>

                    <div class="modal-quote-content">
                      <div class="modal-quote-content__avatar">
                        <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
                      </div>
                      <h5>You can save your quote!</h5>
                      <div class="modal-quote-content__actions">
                        <a href="javascript:void(0);" class="button button--block button--primary" data-toggle="modal"
                        data-target="#savequote-modal">Save Quote</a>
                        <div class="modal-quote-content__or"><span>or</span></div>
                        <a href="javascript:void(0);" class="button button--block button--secondary" data-toggle="modal"
                          data-target="#refresh-alert-modal">
                          <svg class="icon icon--sm">
                            <use xlink:href="#restart"></use>
                          </svg>
                        Restart</a>
                        <p>You will lose all you have done so far</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-session">
                  Session ID: <strong class="session_id">1632302906785</strong>
                </div>

              </div>
            </div>
          </div>

          <div class="modal fade modal--tray" id="modal-policy-menu" tabindex="-1" role="dialog"
            aria-labelledby="modal-traymenu-more" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-traymenu">
                <div class="container">
                  <div class="modal-traymenu__list list-unstyled">
                    <a routerLink="/everything.policy-overview" data-dismiss="modal"
                      class="modal-traymenu__list-item {{router.url==='/everything.policy-overview'?'is-active':''}}">
                      <svg class="icon">
                        <use xlink:href="#policy-overview"></use>
                      </svg>
                      <div>Policy Overview</div>
                    </a>
                    <a routerLink="/everything.policy-insured-items" data-dismiss="modal"
                      class="modal-traymenu__list-item {{router.url==='/everything.policy-insured-items'?'is-active':''}}">
                      <svg class="icon">
                        <use xlink:href="#insured-items"></use>
                      </svg>
                      <div>Insured Items</div>
                    </a>
                    <a routerLink="/everything.policy-addons" data-dismiss="modal"
                      class="modal-traymenu__list-item {{router.url==='/everything.policy-addons'?'is-active':''}}">
                      <svg class="icon">
                        <use xlink:href="#policy-benefits"></use>
                      </svg>
                      <div>Benefits</div>
                    </a>
                    <a routerLink="/everything.policy-resources" data-dismiss="modal"
                      class="modal-traymenu__list-item {{router.url==='/everything.policy-resources'?'is-active':''}}">
                      <svg class="icon">
                        <use xlink:href="#policy-resources"></use>
                      </svg>
                      <div>Resources</div>
                    </a>
                    <!-- <a routerLink="/everything.policy-wording" data-dismiss="modal" class="modal-traymenu__list-item ">
                    <svg class="icon">
                      <use xlink:href="#policy-resources"></use>
                    </svg>
                    <div>Wording</div>
                  </a>
                  <a routerLink="/everything.policy-schedule" data-dismiss="modal" class="modal-traymenu__list-item">
                    <svg class="icon">
                      <use xlink:href="#policy-resources"></use>
                    </svg>
                    <div>Schedule</div>
                  </a> -->
                </div>
                <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                  <div>Close</div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!--Save Quote Modal-->
        <div class="modal fade modal--alert modal--save" id="savequote-modal" tabindex="-1" role="dialog"
          aria-labelledby="savequote-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--savequote">

              <div class="modal-alert__heading">
                <div class="container">
                  <div class="modal-alert__avatar d-none d-md-block">
                    <img src="assets/3/icn/save-quote.svg" class="img-fluid" alt="">
                  </div>

                  <button class="modal-alert__close" data-dismiss="modal">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="modal-alert__content">
                <div class="container">
                  <div class="modal-alert__content-icon d-md-none">
                    <img src="assets/3/icn/save-quote.svg" class="img-fluid" alt=""/>
                  </div>
                  <div class="rte">
                    <h3>Save Quote</h3>
                    <p>Get your quote sent to your inbox. We will send you a secure link for you to access any time.</p>
                  </div>

                  <div class="form-group form-group--sm">
                    <label>Email Address</label>
                    <input type="email" class="form-control save-email" value="{{person?.person_email}}" placeholder=""/>
                  </div>

                  <div class="form-group form-group--sm">
                    <label>Mobile Number</label>
                    <input type="tel" class="form-control save-mobile" value="{{person?.person_tel}}" placeholder=""/>
                  </div>
                  @if (downloadQuote) {
                    <p><a href="{{quoteUrl}}" target="_blank">Click here to download quote. </a> </p>
                  }
                  <div class="modal-alert__content-btn">
                    <a href="javascript:void(0);" (click)="sendQuote()" class="button button--lg button--primary">Send Quote</a>
                  </div>

                  <p class="helper-text">We don’t spam and we don’t share your information with anyone.</p>

                </div>
              </div>

            </div>
          </div>
        </div>

        <!--Restart Quote Modal-->
        <div class="modal fade modal--alert" id="refresh-alert-modal" tabindex="-1" role="dialog"
          aria-labelledby="refresh-alert-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--alt">
              <div class="modal-alert__heading">
                <div class="container">
                  <div class="modal-alert__avatar">
                    <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <a href="#" class="modal-alert__close" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  </a>
                </div>
              </div>

              <div class="modal-alert__content">
                <div class="container">
                  <div class="rte">
                    @if (person?.first_name) {
                      <h3>{{person?.first_name}}, are you sure you want to restart?</h3>
                    }
                    @if (!person?.first_name) {
                      <h3>Are you sure you want to restart?</h3>
                    }
                    <p>You will lose all you have done so far.</p>
                  </div>
                </div>
              </div>

              <div class="modal-alert__button">
                <div class="container">
                  @if (flow_type_id === 3) {
                    <a href="javascript:void(0);" (click)="exitClaim()"
                    class="button button--lg button--secondary" data-dismiss="modal">Yes, please do it</a>
                  }
                  @if (flow_type_id !== 3) {
                    <a href="javascript:void(0);" (click)="resetQuoteStore()"
                    class="button button--lg button--secondary" data-dismiss="modal">Yes, please do it</a>
                  }
                  <a href="javascript:void(0);" class="button button--lg button--primary" data-dismiss="modal">No, please don't</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade modal--mini" id="exit-modal" tabindex="-1" role="dialog" aria-labelledby="exit-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">

            <div class="modal-content modal-mini">
              <div class="modal-mini__heading">
                <div class="container-fluid">
                  <h4>Are you sure you want to exit?</h4>
                  <button class="modal-mini__heading-close" data-dismiss="modal">
                    <svg class="icon">
                      <use xlink:href="#close-medium"></use>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="modal-mini__content">
                <div class="container-fluid">
                  <div class="rte">
                    <p>Did you know that you can save the changes you made to your cover as a quote and continue at a later
                    stage.</p>
                  </div>
                </div>
              </div>

              <div class="modal-mini__button">
                <div class="container-fluid">
                  <a href="javascript:void(0);" (click)="discardQuote()" class="button button--secondary"
                  data-toggle="modal" data-dismiss="modal">Discard quote</a>
                  <a href="javascript:void(0);" (click)="resetQuoteStore()" class="button button--primary"
                  data-toggle="modal" data-dismiss="modal">Save and close</a>
                </div>
              </div>

            </div>


          </div>
        </div>


        <div class="modal fade modal--alert" id="save-claim-modal" tabindex="-1" role="dialog" aria-labelledby="emergency-services-modal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--alt">

              <div class="modal-alert__heading">
                <div class="container">
                  <div class="modal-alert__avatar confetti-pattern-2">
                    <!-- Placeholder image -->
                    <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <button class="modal-alert__close" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  </button>
                </div>
              </div>

              <div class="modal-alert__content">
                <div class="container">
                  <div class="rte">
                    <h3 class="font-normal"><strong>We will autosave your claim as you progress.</strong></h3>
                    <p>You can find your Claim in this app’s Claim tab. Please remember to complete and submit your claim once you are done.</p>
                  </div>
                </div>
              </div>

              <div class="modal-alert__button">
                <div class="container">
                  <a href="javascript:void(0);" (click)="exitClaim()" data-dismiss="modal" class="button button--lg button--secondary">Exit Claim</a>
                  <a href="javascript:void(0);" data-dismiss="modal" class="button button--lg button--primary">Continue Claim</a>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="modal fade modal--alert" id="close-claim-modal" tabindex="-1" role="dialog" aria-labelledby="emergency-services-modal" aria-hidden="true" style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--alt">

              <div class="modal-alert__heading">
                <div class="container">
                  <div class="modal-alert__avatar confetti-pattern-2">
                    <!-- Placeholder image -->
                    <img src="assets/{{sessionDetails?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <button class="modal-alert__close" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  </button>
                </div>
              </div>

              <div class="modal-alert__content">
                <div class="container">
                  <div class="rte">
                    <h3 class="font-normal"><strong>We have saved your claim.</strong></h3>
                    <p>You can find your Claim in this app’s Claim tab. Please remember to complete and submit your claim once you are done.</p>
                  </div>
                </div>
              </div>

              <div class="modal-alert__button">
                <div class="container">
                  <a href="javascript:void(0);" data-dismiss="modal" class="button button--lg button--secondary">Continue Claim</a>
                  <a href="javascript:void(0);" (click)="exitClaim()" data-dismiss="modal" class="button button--lg button--primary">Exit Claim</a>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- separate code for mobile claims feed -->
        <div class="modal fade modal--fullscreen modal--tray" id="modal-claim-feed" tabindex="-1" role="dialog" aria-labelledby="mobile-quote-menu" aria-modal="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-traymenu modal-traymenu--fs modal-traymenu--claims">
              <div class="modal-claimsfeed__heading">
                <div class="container">
                  <a href="javascript:void(0);" class="modal-claimsfeed__close" data-dismiss="modal">
                    <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  </a>
                </div>
              </div>
              <div class="modal-claimsfeed__content">
                <div class="container">
                  <!-- duplication of desktop quote progress, less the subtotal row -->

                  <div class="quote-progress__content">

                    <div class="progress-tree progress-tree--quotes">

                      <div class="progress-tree__item is-complete">
                        <div class="progress-tree__branch">
                          <span><span></span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>Personal Details</p>
                          </div>
                          <div class="progress-tree__detail">
                            <div class="progress-tree__detail-name" title="Bongani Lungani">Bongani Lungani</div>
                            <div class="progress-tree__detail-track">
                              <div class="progress-tree__detail-trackfill" style="width:100%"></div>
                            </div>
                            <div class="progress-tree__detail-actions">
                              <a href="javascript:void(0);" class="action-remove text-link">Edit</a>
                            </div>


                          </div>
                        </div>
                      </div>

                      <div class="progress-tree__item is-active">
                        <div class="progress-tree__branch">
                          <span><span></span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>Vehicles</p>
                          </div>

                          <div class="progress-tree__detail">
                            <div class="progress-tree__detail-name" title="CAA 156893">CAA 156893</div>
                            <div class="progress-tree__detail-cost"><p><strong>R 99 999</strong> /mo</p></div>

                            <div class="progress-tree__detail-description">2016 Suzuki Jimny</div>

                            <div class="progress-tree__detail-track">
                              <div class="progress-tree__detail-trackfill" style="width:80%"></div>
                            </div>

                            <div class="progress-tree__detail-actions">
                              <a href="javascript:void(0);" class="action-remove text-link">Edit</a>
                              <span>|</span>
                              <a href="javascript:void(0);" class="action-remove text-link">Remove</a>
                              <div class="progress-tree__detail-discounts">
                                <svg class="icon"><use xlink:href="#discount-summary-mini"></use></svg>
                              </div>
                            </div>


                          </div>

                          <div class="progress-tree__detail is-active">
                            <div class="progress-tree__detail-name" title="CAA 156893">CAA 156893</div>
                            <div class="progress-tree__detail-cost"><p><strong>R 99 999</strong> /mo</p></div>

                            <div class="progress-tree__detail-description">2016 Suzuki Jimny</div>

                            <div class="progress-tree__detail-track">
                              <div class="progress-tree__detail-trackfill" style="width:80%"></div>
                            </div>

                            <div class="progress-tree__detail-actions">
                              <a href="javascript:void(0);" class="action-remove text-link">Edit</a>
                              <span>|</span>
                              <a href="javascript:void(0);" class="action-remove text-link">Remove</a>
                              <div class="progress-tree__detail-discounts">
                                <svg class="icon"><use xlink:href="#discount-summary-mini"></use></svg>
                              </div>
                            </div>


                          </div>

                        </div>
                      </div>

                      <div class="progress-tree__item is-inactive">
                        <div class="progress-tree__branch">
                          <span><span></span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>Buildings</p>
                            <a href="javascript:void(0);" class="action-remove"><svg class="icon" title="remove">
                              <use xlink:href="#close-circle-small"></use></svg>
                            </a>
                          </div>
                          <!-- no detail yet
                          <div class="progress-tree__detail">
                          </div>
                          -->
                        </div>
                      </div>

                      <div class="progress-tree__item is-inactive">
                        <div class="progress-tree__branch">
                          <span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>Contents</p>
                            <a href="javascript:void(0);" class="action-remove">
                              <svg class="icon" title="remove"><use xlink:href="#close-circle-small"></use></svg>
                            </a>
                          </div>
                          <!-- no detail yet
                          <div class="progress-tree__detail">
                          </div>
                          -->
                        </div>
                      </div>


                    </div>
                    <div class="quote-progress__fees">
                      <div class="quote-progress__fees-name">
                        Incl. Taxes &amp; Fees <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam." data-original-title="" title=""><svg class="icon icon--sm"><use xlink:href="#help-Icon"></use></svg></a>
                      </div>
                      <div class="quote-progress__fees-cost">
                        <p><strong>R 9 999.00</strong> /mo</p>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div class="modal-cart__subtotal">
                <div class="container">
                  <div class="modal-cart__subtotal-title">
                    Subtotal
                  </div>
                  <div class="modal-cart__subtotal-cost">
                    <p><strong><em>R 999 999</em>.00</strong> /mo</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade modal--tray" id="nav-action-sheet" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-more" aria-modal="true">
          <div class="modal-dialog">
            <div class="modal-content modal-traymenu">
              <div class="container">
                <div class="modal-traymenu__list list-unstyled">
                  <a href="#savequote-modal" data-dismiss="modal"  data-toggle="modal" class="modal-traymenu__list-item">
                    <svg class="icon"><use xlink:href="#bookmark"></use></svg>
                    <div>Save Quote</div>
                  </a>
                  <a href="#refresh-alert-modal" data-dismiss="modal"  data-toggle="modal" class="modal-traymenu__list-item">
                    <svg class="icon"><use xlink:href="#restart"></use></svg>
                    <div>Restart Quote</div>
                  </a>
                  <a href="#" id="chatActionTrigger" data-dismiss="modal" class="modal-traymenu__list-item">
                    <svg class="icon"><use xlink:href="#chat"></use></svg>
                    <div>Support</div>
                  </a>
                </div>

                <a href="#" data-dismiss="modal" class="modal-traymenu__close">
                  <svg class="icon"><use xlink:href="#close-medium"></use></svg>
                  <div>Close</div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!--Image Damages Modal-->
        <app-damage-images-modal-alt #uploaderModal></app-damage-images-modal-alt>

        <app-damage-images-modal #damageModal></app-damage-images-modal>

        <div class="modal fade modal--alert" id="error-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
          aria-modal="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content modal-alert modal-alert--prorata">
              <div class="modal-alert__heading">
                <div class="container">
                  <div class="modal-alert__avatar">
                    <img [src]="'assets/0/avatar/sad.png'" alt=""
                      class="img-fluid">
                    </div>
                    <button class="modal-alert__close" data-dismiss="modal">
                      <svg class="icon">
                        <use xlink:href="#close-circle-small"></use>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="modal-alert__content">
                  <div class="container">
                    <div class="rte">
                      <h4>Error!</h4>
                      <p>Sorry, we have encountered a system error. Our support team have automatically been notified.
                        <p>If you would like to contact our Support Team for assistance, you can start a chat below</p>
                        <p class="error-text"></p>
                        <p><a href="javascript:;" class="button button--secondary button--primary" (click)="chat.toggle();">
                          <span>Start a Chat</span>
                        </a></p>
                        <p>The reference for this error is as follows:<br>
                          error_log_id: <span class="error-id">...</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="modal-alert__button">
                    <div class="container">
                      <a href="#" class="button button--lg button--primary" data-dismiss="modal">OK</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <app-evi></app-evi>



